import logoImg from "assets/images/logo.png";
import React from "react";
import { Link } from "react-router-dom";

export const Logo: React.VFC = () => (
  <Link to="/">
    <img src={logoImg} width="52.46px" height="42.72px" alt="logo" />
  </Link>
);
